'use strict';

wbApp.filter('wbCurrencyFlt', ['$filter', 'tenantInfo',  
    function ($filter, tenantInfo) {

        function getCurrencySymbol(tenantInfo) {
            switch (tenantInfo.currency) {
                case 'CZK':
                    return ' Kč';
                case 'EUR':
                    return ' €';
                default:
                    return ' Kč';
            }
        }

        return function (data) {
            if (data === null || data === undefined) {
                return '';
            }

            return $filter('number')(data, 2) + getCurrencySymbol(tenantInfo);
        }
}]);